<template>
  <div>
    <!-- <nav-head></nav-head> -->
    <h2 v-if="data !== null && data.length === 0" style="padding: 2rem">
      没有计算记录
    </h2>
    <div class="instanceCellFather">
      <div class="instanceCell" v-for="(d, i) in data" :key="i">
        <h2>
          {{
            `${d.instance_name ? d.instance_name : ""}(iid:${d.instance_id})`
          }}
        </h2>
        <p>
          <span>
            <b>计算时间：</b>
            <span>{{ d.add_time.replace("T", " ") }}</span>
          </span>
          <span v-if="d.file_name" style="margin-left: 2rem">
            <b>使用的文件：</b>
            <span>{{ d.file_name }}</span>
          </span>
        </p>
        <p>
          <b>计算参数：</b>
          <span>{{ d.params }}</span>
        </p>
        <a-row type="flex" justify="end">
          <a-col>
            <a-button
              @click="changeDetail(i, d)"
              shape="round"
              class="marginRightSmall"
            >
              {{ d.detail ? "折叠" : "详情" }}
            </a-button>
            <a-button
              shape="round"
              class="marginRightSmall"
              type="primary"
              @click="calcNew(d.instance_id)"
            >
              重算
            </a-button>
            <a-popconfirm
              title="确认删除此次记录？"
              ok-text="是"
              cancel-text="否"
              @confirm="deleteCalc(i, d)"
            >
              <a-button shape="round" class="marginRightSmall" type="danger">
                删除
              </a-button>
            </a-popconfirm>
          </a-col>
        </a-row>
        <!-- 详情 -->
        <my-result
          v-if="d.detail"
          :result="d.result"
          :showAlert="false"
          class="instanceDetail"
        ></my-result>
      </div>
      <!-- 页码 -->
      <a-pagination
        :total="totalCalc"
        :defaultPageSize="30"
        v-model="currentPage"
        @change="changePage"
      />
    </div>
  </div>
</template>

<script>
import myResult from './result'
export default {
  components: { myResult },
  data() {
    return {
      data: null,
      currentPage: 1,
      totalCalc: 0
    }
  },
  methods: {
    async getCalc() {
      const resp = await this.$http.get(
        '/calc_record/all?page=' + this.currentPage
      )
      this.data = resp.data.records
      for (const d of this.data) {
        d.detail = false
        d.result = null
      }
      if (this.currentPage === 1) {
        this.totalCalc = resp.data.count
      }
    },
    async changeDetail(i, d) {
      d.detail = !d.detail
      if (d.detail & !d.result) {
        const resp = await this.$http.get(`/calc_record/${d.calc_id}/detail`)
        if (resp.status === 200) {
          d.detail = true
          d.result = resp.data
        }
      }
      this.$set(this.data, i, d)
    },
    async calcNew(iid) {
      this.$router.push('/calc/' + iid)
    },
    deleteCalc(i, d) {
      this.data.splice(i, 1)
      this.$http.delete(`/calc_record/${d.calc_id}/delete`)
    },
    changePage() {
      this.getCalc()
      scroll(0, 0)
    }
  },
  created() {
    this.getCalc()
  }
}
</script>

<style>
</style>
